import type { NewUserQuizCopy } from '../types';

export const EN_NEW_USER_QUIZ_COPY = {
  booking: {
    bookedSnackbar: 'Your demo is booked — see you there!',
    bullets: {
      pricing: 'Get clear pricing by volume and support level',
      teams: 'Built for teams: reviewers, glossaries, one library',
      setup: 'See the right setup for your content and workflow',
    },
    description: 'Learn how Rask conveys identity, intent, and context across languages.',
    heading: 'See how it fits your workflow',
    headingSecondLine: 'Book a demo: see Rask in action',
    maybeLater: 'Maybe later',
    rating: '4.7/5 on G2',
    scheduler: {
      openBookingPage: 'Open booking page',
      loadErrorDescription:
        'Your network or region may be blocking the embed. Open the booking page in a new tab instead.',
      loadErrorTitle: "Couldn't load the scheduler",
      loadingLabel: 'Loading the scheduler',
    },
    trustedBy: 'Trusted by global teams',
  },
  controls: {
    back: 'Back',
    continue: 'Continue',
    continueAnyway: 'Continue anyway',
    progress: (currentStep, totalSteps) => `Question ${currentStep} of ${totalSteps}`,
    submitError: "We couldn't save your answers. Please try again.",
  },
  priorityQuestion: {
    title: 'What matters most to you when localizing videos?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Collaborate with team or reviewers' },
      consistent_voice_and_terminology: { label: 'Consistent voice and terminology' },
      fast_results_no_setup: { label: 'Fast results, no setup needed' },
      integration_into_product_or_workflow: { label: 'Integration into our product or workflow' },
      not_sure_yet: { label: 'Not sure yet' },
    },
    subtitle: 'Choose all that apply',
  },
  questions: {
    content_team_size: {
      title: 'How large is your content team?',
      options: {
        just_me: { label: 'Just me' },
        large_team_5_plus: { label: 'A large team', description: '5 or more people' },
        small_team_2_5: { label: 'A small team', description: '2 to 5 people' },
      },
    },
    localization_frequency: {
      title: 'How often do you translate, voice-over, or localize videos?',
      options: {
        continuously: { label: 'Continuously', description: 'Nonstop, ongoing workload' },
        occasionally_quarterly: { label: 'Occasionally', description: 'Roughly every quarter' },
        regularly_monthly: { label: 'Regularly', description: 'Every month' },
        one_time_project: { label: 'One-time project', description: 'A single project, not ongoing' },
      },
    },
    localized_videos_before: {
      title: 'Have you localized videos before?',
      options: {
        false: { label: 'No' },
        true: { label: 'Yes' },
      },
      subtitle: 'A few quick questions to personalize your experience',
    },
    target_language_count: {
      title: 'How many languages are you planning to localize into?',
      options: {
        changes_by_project: { label: 'Changes by project', description: 'No fixed number' },
        four_to_ten: { label: '4 – 10', description: 'Several markets at once' },
        ten_plus: { label: '10+', description: 'Wide, large-scale rollout' },
        two_to_three: { label: '2 – 3', description: 'A couple of markets' },
        one: { label: '1', description: 'Just one language' },
      },
    },
  },
} satisfies NewUserQuizCopy;
